/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col, Label, Button, Alert,
} from 'reactstrap';
import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';

function LocationForm(props) {
  const { onSuccess, t } = props;

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const makeLocation = async (values) => {
    try {
      setLoading(true);
      const result = await post('/api/warehouse/location/create', values);
      setErrorMessage(false);
      onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    zone: Yup.string().required('Zone is required'),
    label: Yup.string().required('Location label is required'),
    type: Yup.string().required('Type is required'),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null && errorMessage !== false) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      <Alert color="success" className="mt-3" isOpen={(errorMessage === false)}>
        {t('Physical Location created successfully')}
      </Alert>
      { em }
      <Formik
        enableReinitialize
        initialValues={{ zone: '', label: '', type: '' }}
        validationSchema={ValidationSchema}
        onSubmit={(values, actions) => {
          makeLocation(values);
        }}
      >
        {({
          touched, setFieldValue, errors, values,
        }) => (
          <Form className="mt-3" autoComplete="off" id="LocationForm">
            <div className="row mt-4 mb-4">
              <Label
                for="zone"
                className="col-sm-3 col-form-label"
              >
                Zone
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.zone && touched.zone ? 'is-invalid' : '')}`}
                  id="zone"
                  name="zone"
                />
                <ErrorMessage
                  name="zone"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mb-4">
              <Label
                for="label"
                className="col-sm-3 col-form-label"
              >
                Label
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.label && touched.label ? 'is-invalid' : '')}`}
                  id="label"
                  name="label"
                />
                <ErrorMessage
                  name="label"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mb-4">
              <Label
                for="type"
                className="col-sm-3 col-form-label"
              >
                Type
              </Label>

              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.type && touched.type ? 'is-invalid' : '')}`}
                  id="type"
                  name="type"
                />
                <ErrorMessage
                  name="type"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

LocationForm.defaultProps = {
  t: () => {},
  onSuccess: () => {},
};

LocationForm.propTypes = {
  onSuccess: PropTypes.func,
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(LocationForm));
